import '../OpFileSelect.css';
import { formatBytes, truncateTextFromMiddle } from '../utils';

export const CustomFileListTemplate = (props) => {
    return (
        <div className={'e-custom-file-list-wrapper'}>
            <span className={'e-custom-file-name'} title={props.name}>{truncateTextFromMiddle(props.name)}</span>
            <br />
            <span className={'e-custom-file-size'}>{formatBytes(props.size)}</span>
            <span
                className={'e-icons e-file-remove-btn'}
                onClick={() => {
                    if (props.ref.current) {
                      props.ref.current.clearAll(); // removes all files from list
                      if (typeof props.onSelectFile == "function")
                        props.onSelectFile(null);
                    }
                }}
                title={'Remove'}
            />
        </div>
    );
};